import type { BulkOrderUpdateJobSummaryResponse } from '@api/useBulkOrderUpdate/types'

interface DurationRendererProps {
  data: BulkOrderUpdateJobSummaryResponse
}

export function DurationRenderer({ data }: DurationRendererProps) {
  const { current_duration_seconds, status } = data

  // Show "Not started" for pending jobs with 0 duration
  if (status === 'pending' && (current_duration_seconds === null || current_duration_seconds === 0)) {
    return <span className='text-gray-400 text-xs'>Not started</span>
  }

  // Show "Waiting" for queued jobs with 0 duration
  if (status === 'queued' && (current_duration_seconds === null || current_duration_seconds === 0)) {
    return <span className='text-gray-400 text-xs'>Waiting</span>
  }

  const value = current_duration_seconds
  if (!value) return <span className='text-gray-400 text-xs'>-</span>

  const hours = Math.floor(value / 3600)
  const minutes = Math.floor((value % 3600) / 60)
  const seconds = Math.floor(value % 60)

  let timeText = ''
  if (hours > 0) {
    timeText = `${hours}h ${minutes}m ${seconds}s`
  } else if (minutes > 0) {
    timeText = `${minutes}m ${seconds}s`
  } else {
    timeText = `${seconds}s`
  }

  // Show "Processing for X" for running jobs
  if (status === 'running') {
    return <span className='text-xs text-blue-600'>Processing {timeText}</span>
  }

  return <span className='text-xs'>{timeText}</span>
}
